export const parseDate = (dateOrString: Date | string) => (dateOrString instanceof Date ? dateOrString : new Date(dateOrString));
